import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "unassaigned-shift",
  "use": "unassaigned-shift-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"unassaigned-shift\"><path d=\"M9.6 5.6H16v1.6H9.6zM4.8 0C2.976 0 1.6 1.376 1.6 3.2s1.376 3.2 3.2 3.2S8 5.024 8 3.2 6.624 0 4.8 0m0 4.8c-.942 0-1.6-.658-1.6-1.6s.658-1.6 1.6-1.6 1.6.658 1.6 1.6-.658 1.6-1.6 1.6m-3.2 6.4c0-1.323 1.077-2.4 2.4-2.4h1.6C6.923 8.8 8 9.877 8 11.2v.8h1.6v-.8c0-2.206-1.794-4-4-4H4c-2.206 0-4 1.794-4 4v.8h1.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol